import { routes } from '@router/index';
import { unsetUserDetails } from '@store/slices/user.slice';
import { RootState } from '@utils/types';
import { Button, Sidebar } from 'flowbite-react';
import Cookies from 'js-cookie';
import { FiLogOut } from 'react-icons/fi';
import { GiScooter } from 'react-icons/gi';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const SideNav = ({ closeDrawer = () => {} }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { segmentCode = '' } = useSelector((state: RootState) => state.user);
  const handleLogOut = () => {
    Cookies.remove('ca_token');
    Cookies.remove('uuid_dp');
    dispatch(unsetUserDetails());
    navigate('/login');
  };
  return (
    <Sidebar
      aria-label="Sidebar with multi-level dropdown example"
      theme={{
        root: {
          collapsed: {
            off: 'w-full',
          },
          inner:
            'h-full overflow-y-auto overflow-x-hidden rounded px-3 py-4 relative',
        },
      }}
    >
      <Sidebar.Items>
        <Sidebar.ItemGroup>
          <Sidebar.Collapse
            icon={GiScooter}
            label="Two-Wheeler Finance"
            theme={{
              label: {
                base: 'ml-3 flex-1 whitespace-nowrap text-left font-semibold',
              },
              button:
                'group flex w-full items-center rounded-lg p-2 text-base font-normal text-gray-900 transition duration-75 bg-gray-100 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700',
            }}
            open
          >
            {routes
              .filter((route) => {
                let check = false;
                if (route?.showInNav === true) {
                  check = true;
                }
                if (
                  route?.excludedRoles !== undefined &&
                  route.excludedRoles.includes(segmentCode)
                ) {
                  check = false;
                }
                return check;
              })
              .map((route, index) => (
                <Sidebar.Item
                  key={index}
                  theme={{
                    base: `flex items-center justify-center rounded-lg p-2 text-base font-normal text-gray-900 ${pathname === route.path ? 'bg-gray-100' : ''} hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 h-4/5 ml-auto cursor-pointer`,
                    collapsed: {
                      insideCollapse:
                        'group w-full ml-8 transition duration-75 w-auto',
                      noIcon: 'font-bold',
                    },
                  }}
                  onClick={(e: React.ChangeEvent<MouseEvent>) => {
                    e.preventDefault();
                    navigate(route.path);
                    closeDrawer();
                  }}
                >
                  <span className="ml-4">{route.title}</span>
                </Sidebar.Item>
              ))}
          </Sidebar.Collapse>
        </Sidebar.ItemGroup>
      </Sidebar.Items>
      <Sidebar.CTA
        theme={{
          base: 'absolute bottom-0 p-4',
        }}
      >
        <div className="mb-3 text-xs font-semibold text-gray-500">
          Contact us
        </div>
        <div className="mb-3 text-xs font-semibold">
          Brindavan, Plot no. 177,CST Road, Kalina, Santacruz (East), Mumbai -
          400 098, Maharashtra, India <br />
          +91 22 6212 5000
        </div>

        <div className="mb-6">
          <Button
            color="red"
            className="flex border-red-500 text-sm text-red-500"
            onClick={handleLogOut}
          >
            Logout <FiLogOut className="ml-4 h-full" />
          </Button>
        </div>
      </Sidebar.CTA>
    </Sidebar>
  );
};

export default SideNav;
